<template>
  <div class="brow-history">
    <div class="search-cons">
      <div class="cons-flex">
        <div class="cons-item" @click="handleClick(0)" :class="curItem === 0 ? 'cur' : ''">
          文献
          <img v-if="curItem === 0" src="../../assets/images/home/underline@2x.png" class="img-btm" alt="">
        </div>
        <div class="cons-item" @click="handleClick(1)" :class="curItem === 1 ? 'cur' : ''">
          病例
          <img v-if="curItem === 1" src="../../assets/images/home/underline@2x.png" class="img-btm" alt="">
        </div>
        <div class="cons-item" @click="handleClick(2)" :class="curItem === 2 ? 'cur' : ''">
          课程
          <img v-if="curItem === 2" src="../../assets/images/home/underline@2x.png" class="img-btm" alt="">
        </div>
      </div>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="cons-list">
        <div class="items" v-for="(item, index) in list" :key="index" @click="handleJump(item)">
          <div class="items-cover-div">
            <img :src="item && item.coverUrl" class="cover" alt="">
          </div>
          <div class="items-info">
            <div class="txt1" v-if="curItem === 2">{{ item && item.courseName }}</div>
            <div class="txt1" v-else>{{ item && item.title }}</div>
            <div class="txt2">
              {{ item && item.times }}
              <!-- <img src="@/assets/images/home/" alt=""> -->
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <returnBack></returnBack>
  </div>
</template>
<script>
import { docuBrowseHistory, caseBrowseHistory, courseBrowseHistory } from '../../api/person'
import { setSha, traceClickURL } from '../../utils/util'
import returnBack from './components/returnBack.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import {isScorm} from '../../api/scorm'
const UserProfile = {
  components: {
    returnBack
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      curItem: 0,
      load: false
    }
  },
  mounted () {
    // window.sessionStorage.removeItem('entrance')
    // window.sessionStorage.removeItem('entrance')
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    handleClick (index) {
      this.curItem = index
      this.pageNum = 1
      this.finished = false
      this.list = []
      this.onLoad()
    },
    onLoad () {
      if (this.load) return
      this.load = true
      if (this.curItem === 0) {
        docuBrowseHistory({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          userId: this.userInfo.id,
          openId: this.userInfo.iepOpenId
        }).then(res => {
          this.load = false
          if (res.data.list.length < this.pageSize) {
            this.finished = true
          }
          res.data.list.map(item => {
            item.times = this.$moment(item.createTime * 1).format('YYYY-MM-DD HH:mm')
          })
          this.list = this.list.concat(res.data.list)
          // 加载状态结束
          this.loading = false
          this.pageNum++
        })
      } else
      if (this.curItem === 1) {
        caseBrowseHistory({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          userId: this.userInfo.id,
          openId: this.userInfo.iepOpenId
        }).then(res => {
          this.load = false
          if (res.data.list.length < this.pageSize) {
            this.finished = true
          }
          res.data.list.map(item => {
            item.times = this.$moment(item.createTime * 1).format('YYYY-MM-DD HH:mm')
          })
          this.list = this.list.concat(res.data.list)
          // 加载状态结束
          this.loading = false
          this.pageNum++
        })
      } else
      if (this.curItem === 2) {
        courseBrowseHistory({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          userId: this.userInfo.id,
          openId: this.userInfo.iepOpenId
        }).then(res => {
          this.load = false
          if (res.data.list.length < this.pageSize) {
            this.finished = true
          }
          res.data.list.map(item => {
            item.times = this.$moment(item.createTime * 1).format('YYYY-MM-DD HH:mm')
          })
          this.list = this.list.concat(res.data.list)
          // 加载状态结束
          this.loading = false
          this.pageNum++
        })
      }
    },
    async handleJump(item) {
      // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
      if (this.curItem === 0) {
        // setTimeout(() => { traceClickURL() })
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.id}${openid}${iepTxt}`
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.id
          }
        })
      } else if (this.curItem === 1) {
        setTimeout(() => { traceClickURL() })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.id}${openidBindli}`
      } else {
        if (`${item.courseStatus}` === '2') {
          this.$toast('课程已下架或删除，可以学习其他内容哦!')
          return
        }
        const query = {
          courseId: item.courseId
        }
        const isscorm = await isScorm(item.courseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.search-cons {
  .cons-flex {
    display: flex;
    align-items: center;
    height: 64px;
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 9;

    .cons-item {
      flex: 1;
      position: relative;
      font-size: 15px;
      color: #5B5F6A;
      font-weight: 500;
      text-align: center;

      &.cur {
        color: #000000;

        .img-btm {
          width: 23px;
          height: 10px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          bottom: -10px;
        }
      }
    }
  }

  .cons-list {
    padding: 0 16px;
    box-sizing: border-box;

    .items {
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;

      .items-cover-div {
        width: 110px;
        height: 60px;
        position: relative;
        margin-right: 12px;

        .cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .items-info {
        flex: 1;

        .txt1 {
          display: -webkit-box;
          -webkit-line-clamp: 2; //显示3行文字
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          margin-bottom: 1px;
          height: 40px;
        }

        .txt2 {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #B1B1B1;
          line-height: 20px;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/browsHistory.vue